/* eslint-disable no-magic-numbers */

import React from 'react';

import { FormattedMessage } from '@futrli/localisation';

import { DELETED_FORMULA_REFERENCE_CODE } from '../../../../utils/formulas/types';
import { FormulaErrorCode } from '../types';

import styles from './formula-errors.scss';

export interface FormulaErrorsProps {
  formulaContent?: string;
  formulaErrorCode?: FormulaErrorCode;
  show?: boolean;
}

export const FormulaErrors = ({ formulaContent, formulaErrorCode, show }: FormulaErrorsProps) => {
  if (!show) {
    return null;
  }

  const renderError = () => {
    if (formulaErrorCode === FormulaErrorCode.ERROR_CIRCULAR_REFERENCE) {
      return (
        <FormattedMessage
          id="predict.formula_error_circular_reference"
          defaultMessage="Your formula cannot be saved, as it will create a circular reference."
        />
      );
    }

    if (formulaErrorCode === FormulaErrorCode.ERROR_INVALID_REFERENCE) {
      return (
        <FormattedMessage
          id="predict.formula_error_invalid_reference"
          defaultMessage="Your formula cannot be saved as it contains an invalid reference."
        />
      );
    }

    if (formulaContent?.includes(`@${DELETED_FORMULA_REFERENCE_CODE}`)) {
      return (
        <FormattedMessage
          id="predict.edit_required_account_not_valid"
          defaultMessage="Edit required - account is no longer valid."
        />
      );
    }

    return (
      <FormattedMessage
        id="predict.keep_editing_formula_not_ready"
        defaultMessage="Keep editing - your formula is not yet ready to be saved."
      />
    );
  };

  return <div className={styles.formulaError}>{renderError()}</div>;
};
